import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosInstance';

const ProjectsAdmin = () => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
      axiosInstance.get('/projects')
        .then(response => setProjects(response.data))
        .catch(error => console.error('Error fetching projects:', error));
    }, []);
  
    const handleDelete = (id) => {
        axiosInstance.delete(`/projects/${id}`)
        .then(() => setProjects(projects.filter(project => project._id !== id)))
        .catch(error => console.error('Error deleting project:', error));
    };

    const truncateDescription = (description, maxLength) => {
      if (description.length > maxLength) {
        return description.substring(0, maxLength) + '...';
      }
      return description;
    };
  
    return (
      <div className="max-w-7xl mx-auto px-4">
        <div className="py-8">
            <h2 className="text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]">Projects</h2>
          <div className="py-4">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg ">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 dark:bg-black">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-900 dark:text-[rgb(211,219,236)] uppercase tracking-wider">Title</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-900 dark:text-[rgb(211,219,236)] uppercase tracking-wider">Description</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-900 dark:text-[rgb(211,219,236)] uppercase tracking-wider">Technologies</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-900 dark:text-[rgb(211,219,236)] uppercase tracking-wider">Image</th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-900 dark:text-[rgb(211,219,236)] uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-gray-50 dark:bg-black divide-y divide-gray-200">
                  {projects.map((project) => (
                    <tr key={project._id}>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-900 dark:text-[rgb(211,219,236)]">{project.title}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-900 dark:text-[rgb(211,219,236)] w-6 relative"> {truncateDescription(project.description, 50)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-900 dark:text-[rgb(211,219,236)]">{project.technologies.join(', ')}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-gray-900 dark:text-[rgb(211,219,236)]">
                        {project.media && <img src={project.media} alt={project.title} className="w-16 h-16 object-cover" />}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex items-center justify-start">
                        <button className="text-gray-900 dark:text-[rgb(211,219,236)] hover:text-indigo-900 pr-4">Edit</button>
                        <button className="text-red-600 hover:text-red-900" onClick={() => handleDelete(project._id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default ProjectsAdmin;
